import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const ProspectProfileSectionSkeleton: React.FC = () => (
  <div className="prospect-profile-section-skeleton">
    <div className="prospect-profile-section-header">
      <div className="d-flex align-items-center gap-12">
        <SkeletonLoading width={64} height={64} circle />
        <div className="d-flex flex-column gap-4">
          <SkeletonLoading width={161} height={20} />
          <SkeletonLoading width={97} height={14} />
          <div className="d-flex align-items-center gap-16">
            {Array.from({ length: 3 }).map(() => (
              <SkeletonLoading width={18} height={18} circle />
            ))}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center gap-8">
        <SkeletonLoading width={49} height={14} />
        <SkeletonLoading width={55} height={14} />
        <SkeletonLoading width={24} height={14} />
      </div>
      <div className="d-flex align-items-center gap-16">
        {Array.from({ length: 6 }).map(() => (
          <SkeletonLoading width={32} height={32} circle />
        ))}
      </div>
    </div>
    <div className="prospect-profile-section-body-container">
      <div className="prospect-profile-section-count-container">
        {Array.from({ length: 5 }).map(() => (
          <>
            <div className="prospect-profile-section-count">
              <SkeletonLoading width={24} height={24} />
              <SkeletonLoading width='100%' height={14} />
            </div>
          </>
        ))}
      </div>
      {Array.from({ length: 8 }).map(() => (
        <div className="prospect-profile-section-fields">
          <SkeletonLoading width={103} height={14} />
          <SkeletonLoading width={267} height={14} />
        </div>
      ))}
    </div>
  </div>
);

export default ProspectProfileSectionSkeleton;
